import { DropdownOptionType } from '../../components/Dropdown/Type';

export const ACCOUNT_TAG: Array<DropdownOptionType> = [
  { display: 'Freight Forwarder', value: 'freight_forwarder' },
  { display: 'Courier Agent', value: 'courier_agent' },
  { display: 'E-Commerce', value: 'e_commerce' },
  { display: 'Corporate', value: 'corporate' },
  // { display: 'Organic', value: 'organic' },
];
